import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SaveFormService } from "../services/save-form.service";

@Component({
	selector: "app-personal-data",
	templateUrl: "./personal-data.component.html",
	styleUrls: ["./personal-data.component.scss"],
})
export class PersonalDataComponent implements OnInit {
	form!: FormGroup;

	surname = "";
	firstname = "";
	lastname = "";
	phone = "";

	constructor(
		private router: Router,
		private saveFormService: SaveFormService,
		private translateService: TranslateService
	) {}

	ngOnInit() {
		this.initForm();
	}

	initForm(): void {
		if (localStorage.hasOwnProperty("form")) {
			this.surname = this.saveFormService.getFormData().personalData.surname;
			this.firstname = this.saveFormService.getFormData().personalData.firstname;
			this.lastname = this.saveFormService.getFormData().personalData.lastname;
			this.phone = this.saveFormService.getFormData().personalData.phone.substring(2);
		} else {
			this.saveFormService.initFormLocalStorage();
		}

		this.form = new FormGroup({
			surnameFormControl: new FormControl(this.surname, [Validators.required, Validators.pattern(/(^[A-Za-zа-яА-ЯёЁӘІҢҒҮҰҚӨҺәіңғүұқөһ-]*$)/)]),
			firstnameFormControl: new FormControl(this.firstname, [Validators.required, Validators.pattern(/(^[A-Za-zа-яА-ЯёЁӘІҢҒҮҰҚӨҺәіңғүұқөһ-]*$)/)]),
			lastnameFormControl: new FormControl(this.lastname, [Validators.pattern(/(^[A-Za-zа-яА-ЯёЁӘІҢҒҮҰҚӨҺәіңғүұқөһ-]*$)/)]),
			phoneFormControl: new FormControl(this.phone, [Validators.required, Validators.minLength(10)]),
		});
	}

	get surnameFormatError() {
		return this.form.get("surnameFormControl")?.hasError("pattern");
	}

	get surnameRequiredError() {
		return this.form.get("surnameFormControl")?.hasError("required");
	}

	get firstnameFormatError() {
		return this.form.get("firstnameFormControl")?.hasError("pattern");
	}

	get firstnameRequiredError() {
		return this.form.get("firstnameFormControl")?.hasError("required");
	}

	get lastnameFormatError() {
		return this.form.get("lastnameFormControl")?.hasError("pattern");
	}

	get lastnameRequiredError() {
		return this.form.get("lastnameFormControl")?.hasError("required");
	}

	get phoneRequiredError() {
		return this.form.get("phoneFormControl")?.hasError("required");
	}

	get phoneFormatError() {
		return this.form.get("phoneFormControl")?.hasError("minlength");
	}

	saveData() {
		const surname = this.form.get("surnameFormControl")?.value.trim();
		const firstname = this.form.get("firstnameFormControl")?.value.trim();
		const lastname = this.form.get("lastnameFormControl")?.value.trim();
		const phone = `+7${this.form.get("phoneFormControl")?.value.trim()}`;

		this.saveFormService.savePersonalData(surname, firstname, lastname, phone);
	}

	sendForm() {
		this.router.navigate(["/register/company-data"]);
	}
}
